"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[363],{

/***/ 21206:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ recursiveApplyTransformation; }
/* harmony export */ });
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76635);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);

const recursiveApplyTransformation = (/* eslint-disable @typescript-eslint/no-explicit-any */ value, transformation)=>{
    /* eslint-enable @typescript-eslint/no-explicit-any */ if (value == null) return value;
    if (value instanceof File) return value;
    if (typeof value === "string") {
        return transformation(value);
    }
    if (Array.isArray(value)) {
        return value.map((val)=>recursiveApplyTransformation(val, transformation));
    }
    if (typeof value === "object") {
        if (value instanceof Blob || value instanceof File) return value;
        if (value instanceof Date) return value;
        return (0,lodash__WEBPACK_IMPORTED_MODULE_0__.mapValues)(value, (val)=>recursiveApplyTransformation(val, transformation));
    }
    return value;
};


/***/ }),

/***/ 36284:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ normalize; }
/* harmony export */ });
const normalize = (phone)=>{
    const plainNumbers = phone === null || phone === void 0 ? void 0 : phone.replace(/\D/g, "");
    return "+".concat(!(plainNumbers === null || plainNumbers === void 0 ? void 0 : plainNumbers.startsWith("1")) ? "1" : "").concat(plainNumbers);
};


/***/ }),

/***/ 72363:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "B": function() { return /* binding */ AuthForm; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/@sentry/minimal/esm/index.js + 1 modules
var esm = __webpack_require__(95876);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/ui-components/src/lib/common/atoms/Form/index.tsx
var Form = __webpack_require__(72131);
// EXTERNAL MODULE: ../../libs/common-utils/src/phone.ts
var src_phone = __webpack_require__(36284);
// EXTERNAL MODULE: ../../node_modules/firebase/auth/dist/index.esm.js + 2 modules
var index_esm = __webpack_require__(3797);
// EXTERNAL MODULE: ../../libs/frontend-utils/src/firebase/auth/initializeAuth.ts
var initializeAuth = __webpack_require__(90854);
;// CONCATENATED MODULE: ../../libs/frontend-utils/src/firebase/auth/phone.ts




const usePhoneAuthentication = ()=>{
    const [status, setStatus] = (0,react.useState)("initial");
    const [confirmationResult, setConfirmationResult] = (0,react.useState)();
    const [verificationId, setVerificationId] = (0,react.useState)();
    const verifierInstance = (0,react.useRef)();
    const setNewRecaptchaVerifierInstance = (0,react.useCallback)(()=>{
        return new Promise((resolve)=>{
            try {
                verifierInstance.current = new index_esm/* RecaptchaVerifier */.lI("verification-button", {
                    size: "invisible"
                }, initializeAuth/* auth */.I);
                resolve();
            } catch (e) {
                console.error(e);
            }
        });
    }, []);
    const reset = (0,react.useCallback)(()=>{
        setStatus("initial");
        setConfirmationResult(undefined);
    }, [
        setConfirmationResult
    ]);
    const authenticate = (0,react.useCallback)(async (phoneNumber)=>{
        if (!verifierInstance.current) throw new Error("Failed to initialize reCAPTCHA");
        setStatus("verification_loading");
        const confirmationResult = await (0,index_esm/* signInWithPhoneNumber */.$g)(initializeAuth/* auth */.I, src_phone/* normalize */.F(phoneNumber), verifierInstance.current).catch((e)=>{
            setStatus("initial");
            throw e;
        });
        setStatus("verification");
        setConfirmationResult(confirmationResult);
    }, []);
    const verifyCode = (0,react.useCallback)(async (code)=>{
        if (!confirmationResult) {
            throw new Error("Phone number was not provided.");
        }
        if (!code) {
            throw new Error("Verification code was not provided.");
        }
        setStatus("confirming");
        const userCredentials = await confirmationResult.confirm(code).catch((e)=>{
            setStatus("verification");
            throw e;
        });
        setStatus("confirmed");
        return userCredentials.user;
    }, [
        confirmationResult
    ]);
    const sendVerificationCode = (0,react.useCallback)(async (phoneNumber)=>{
        if (!verifierInstance.current) throw new Error("Failed to initialize reCAPTCHA");
        const provider = new index_esm/* PhoneAuthProvider */.RO(initializeAuth/* auth */.I);
        setStatus("verification_loading");
        const verificationId = await provider.verifyPhoneNumber({
            phoneNumber
        }, verifierInstance.current).catch((e)=>{
            setStatus("initial");
            throw e;
        });
        setStatus("verification");
        setVerificationId(verificationId);
    }, []);
    const updatePhone = (0,react.useCallback)(async (verificationCode)=>{
        if (!verificationId) {
            throw new Error("Phone number was not provided.");
        } else if (!initializeAuth/* auth.currentUser */.I.currentUser) {
            throw new Error("User is not signed in");
        }
        const credential = index_esm/* PhoneAuthProvider.credential */.RO.credential(verificationId, verificationCode);
        await (0,index_esm/* updatePhoneNumber */.Rv)(initializeAuth/* auth.currentUser */.I.currentUser, credential);
        return initializeAuth/* auth.currentUser */.I.currentUser;
    }, [
        verificationId
    ]);
    return {
        wasPhoneNumberProvided: !!confirmationResult || !!verificationId,
        isVerificationLoading: status === "verification_loading",
        setNewRecaptchaVerifierInstance,
        /* login, signup, acceptInvitation */ authenticate,
        verifyCode,
        reset,
        /* changePhone */ sendVerificationCode,
        updatePhone
    };
};

// EXTERNAL MODULE: ../../libs/frontend-utils/src/message/index.ts
var message = __webpack_require__(7476);
// EXTERNAL MODULE: ../../libs/ui-components/src/lib/common/atoms/FormItem/index.tsx + 3 modules
var FormItem = __webpack_require__(74606);
// EXTERNAL MODULE: ../../libs/ui-components/src/lib/common/atoms/Input/index.tsx + 1 modules
var Input = __webpack_require__(68880);
// EXTERNAL MODULE: ../../libs/ui-components/src/lib/common/atoms/Button/index.tsx + 1 modules
var Button = __webpack_require__(81824);
// EXTERNAL MODULE: ../../libs/ui-components/src/lib/common/atoms/Select/index.tsx + 1 modules
var Select = __webpack_require__(61035);
;// CONCATENATED MODULE: ../../libs/ui-components/src/lib/common/PhoneInput/validations.ts
const validations = [
    {
        required: true,
        message: "Phone number is required"
    },
    {
        validator: (_, value)=>{
            if ((value === null || value === void 0 ? void 0 : value.length) < 12) {
                return Promise.reject("Enter a valid phone number");
            }
            return Promise.resolve();
        }
    }
];
/* harmony default export */ var PhoneInput_validations = (validations);

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(58694);
// EXTERNAL MODULE: ../../node_modules/react-phone-input-2/lib/lib.js
var lib = __webpack_require__(84695);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
;// CONCATENATED MODULE: ../../libs/ui-components/src/lib/common/PhoneInput/styles.ts

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  & .ant-input {\n    padding: 13px 12px;\n    border-radius: 12px;\n    font-size: 15px;\n    line-height: 140%;\n  }\n\n  & .ant-input:focus,\n  & .ant-input:hover {\n    border-color: ",
        ";\n    box-shadow: none;\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}


const Wrap = styled_components_browser_esm/* default.div */.ZP.div(_templateObject(), (param)=>{
    let { theme  } = param;
    return theme.colors.black30;
});
const styles_Input = (0,styled_components_browser_esm/* default */.ZP)((lib_default()))(_templateObject1());

;// CONCATENATED MODULE: ../../libs/ui-components/src/lib/common/PhoneInput/index.tsx





const PhoneInput = (param)=>{
    let { onChange , ...props } = param;
    const handleOnChange = (0,react.useCallback)((value, data, event, formattedValue)=>{
        return onChange === null || onChange === void 0 ? void 0 : onChange(src_phone/* normalize */.F(value), data, event, formattedValue);
    }, [
        onChange
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrap, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_Input, {
            inputClass: "ant-input",
            specialLabel: "",
            disableDropdown: true,
            onChange: handleOnChange,
            ...props
        })
    });
};

;// CONCATENATED MODULE: ../../libs/frontend-utils/src/hooks/useEnterPressed.ts

const useEnterPressed = (callback)=>{
    return (0,react.useCallback)((e)=>{
        if (e.key === "Enter") return callback();
    }, [
        callback
    ]);
};

// EXTERNAL MODULE: ../../libs/frontend-utils/src/next/ClientSide.tsx
var ClientSide = __webpack_require__(50110);
;// CONCATENATED MODULE: ../../libs/common-utils/src/domain/vetter.ts
const checkAllValuesAreTruthy = function() {
    for(var _len = arguments.length, profileData = new Array(_len), _key = 0; _key < _len; _key++){
        profileData[_key] = arguments[_key];
    }
    return profileData.every((i)=>Boolean(i));
};
const validImageFileTypes = new Set([
    "image/jpeg",
    "image/png",
    "image/gif",
    "image/webp"
]);
const isValidImageFileType = (fileType)=>validImageFileTypes.has(fileType.toLowerCase());
const VetterChannels = [
    {
        value: "Search Engine",
        text: "Search Engine"
    },
    {
        value: "Advertising",
        text: "Advertising"
    },
    {
        value: "Social media",
        text: "Social media"
    },
    {
        value: "Word of mouth",
        text: "Word of mouth"
    },
    {
        value: "Conference",
        text: "Conference"
    },
    {
        value: "Existing Vetter",
        text: "Existing Vetter"
    },
    {
        value: "Other",
        text: "Other"
    }
];

// EXTERNAL MODULE: ../../node_modules/antd/es/grid/index.js
var grid = __webpack_require__(68358);
// EXTERNAL MODULE: ../../node_modules/antd/es/row/index.js
var row = __webpack_require__(3306);
// EXTERNAL MODULE: ../../node_modules/antd/es/col/index.js
var col = __webpack_require__(3086);
;// CONCATENATED MODULE: ../../libs/ui-components/src/lib/common/PhoneAuthenticationForm/AuthForm/validations.ts
const validations_validations = {
    code: [
        {
            required: true,
            message: "Verification code is required"
        }
    ],
    firstName: [
        {
            required: true,
            message: "First name is required"
        }
    ],
    lastName: [
        {
            required: true,
            message: "Last name is required"
        }
    ]
};

;// CONCATENATED MODULE: ../../libs/ui-components/src/lib/common/PhoneAuthenticationForm/AuthForm/styles.ts

function styles_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  overflow-y: auto;\n\n  & > *:not(:first-child) {\n    margin-top: 12px;\n  }\n  & > *:not(:last-child) {\n    margin-bottom: 12px;\n  }\n"
    ]);
    styles_templateObject = function() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 100%;\n"
    ]);
    styles_templateObject1 = function() {
        return data;
    };
    return data;
}


const Wrapper = (0,styled_components_browser_esm/* default */.ZP)(row/* default */.Z)(styles_templateObject());
const Col = (0,styled_components_browser_esm/* default */.ZP)(col/* default */.Z)(styles_templateObject1());

;// CONCATENATED MODULE: ../../libs/ui-components/src/lib/common/PhoneAuthenticationForm/AuthForm/Form.tsx









const RESEND_TIMEOUT_SECONDS = 30;
const Form_Form = /*#__PURE__*/ (0,react.forwardRef)((param, ref)=>{
    let { form , header , onAuthenticate , onVerify , verificationDisabled , buttonText , phoneNumberLabel , gatherChannel , gatherName , isVerificationLoading  } = param;
    const { xs  } = grid/* default.useBreakpoint */.ZP.useBreakpoint();
    const verificationCodeInputRef = (0,react.useRef)(null);
    const verifyOnEnter = useEnterPressed(onVerify);
    const inputPhone = Form/* Form.useWatch */.l.useWatch([
        "phone"
    ], form);
    const channel = Form/* Form.useWatch */.l.useWatch([
        "channel"
    ], form);
    const isValidPhone = (0,react.useMemo)(()=>{
        return inputPhone && inputPhone.length === 12;
    }, [
        inputPhone
    ]);
    const [sendOTPTimeout, setSendOTPTimeout] = (0,react.useState)(0);
    const getVerificationHint = ()=>{
        if (verificationDisabled) return "";
        const hasVerificationError = form.getFieldsError([
            "verificationCode"
        ]).some((param)=>{
            let { errors  } = param;
            return errors.length > 0;
        });
        if (hasVerificationError) return "";
        return "Enter the verification code we sent to your phone";
    };
    (0,react.useImperativeHandle)(ref, ()=>{
        return {
            focusVerificationCodeInput: ()=>{
                var ref;
                (ref = verificationCodeInputRef.current) === null || ref === void 0 ? void 0 : ref.focus();
            }
        };
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* Form */.l, {
        form: form,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ClientSide/* ClientSide */.B, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
                $xs: xs,
                align: "stretch",
                children: [
                    header,
                    gatherName && /*#__PURE__*/ (0,jsx_runtime.jsx)(Col, {
                        span: 12,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(row/* default */.Z, {
                            justify: "space-between",
                            gutter: [
                                24,
                                24
                            ],
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                    sm: 12,
                                    xs: 24,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormItem/* FormItem */.x, {
                                        label: "First name",
                                        name: "firstName",
                                        rules: validations_validations.firstName,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* Input */.I, {
                                            "aria-label": "first name"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                    sm: 12,
                                    xs: 24,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormItem/* FormItem */.x, {
                                        label: "Last name",
                                        name: "lastName",
                                        rules: validations_validations.lastName,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* Input */.I, {
                                            "aria-label": "last name"
                                        })
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormItem/* FormItem */.x, {
                        label: phoneNumberLabel || "Phone number",
                        name: "phone",
                        validateTrigger: [
                            "onChange"
                        ],
                        rules: PhoneInput_validations,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PhoneInput, {
                            onEnterKeyPress: ()=>isValidPhone && onAuthenticate(),
                            inputProps: {
                                "aria-label": "phone number"
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormItem/* FormItem */.x, {
                        shouldUpdate: true,
                        noStyle: true,
                        children: ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                id: "verification-button",
                                "aria-label": "send verification code",
                                size: "small",
                                loading: isVerificationLoading,
                                actionType: "secondary",
                                disabled: !isValidPhone || sendOTPTimeout > 0,
                                onClick: async ()=>{
                                    const isSuccessful = await onAuthenticate();
                                    if (isSuccessful) {
                                        setSendOTPTimeout(RESEND_TIMEOUT_SECONDS);
                                        const interval = setInterval(()=>{
                                            setSendOTPTimeout((val)=>val - 1);
                                        }, 1000);
                                        setTimeout(()=>{
                                            clearInterval(interval);
                                        }, (RESEND_TIMEOUT_SECONDS + 1) * 1000);
                                    }
                                },
                                children: sendOTPTimeout > 0 ? "Resend verification code in ".concat(sendOTPTimeout, "s") : "Send verification code"
                            })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormItem/* FormItem */.x, {
                        label: "Verification code",
                        name: "verificationCode",
                        validateTrigger: [
                            "onChange"
                        ],
                        rules: validations_validations.code,
                        shouldUpdate: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* Input */.I, {
                            ref: verificationCodeInputRef,
                            id: "verificationCode",
                            size: "large",
                            onKeyUp: verifyOnEnter,
                            disabled: verificationDisabled,
                            optionalText: getVerificationHint(),
                            "aria-label": "verification code"
                        })
                    }),
                    gatherChannel && /*#__PURE__*/ (0,jsx_runtime.jsx)(FormItem/* FormItem */.x, {
                        label: "How did you hear about Vette?",
                        name: "channel",
                        rules: [
                            {
                                required: true,
                                message: "Please fill out information"
                            }
                        ],
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Select/* Select */.P, {
                            placeholder: "Please choose one",
                            size: "large",
                            option: VetterChannels,
                            disabled: verificationDisabled,
                            "aria-label": "how did you hear about Vette dropdown"
                        })
                    }),
                    channel === "Other" && /*#__PURE__*/ (0,jsx_runtime.jsx)(FormItem/* FormItem */.x, {
                        label: "Please specify",
                        name: "otherChannel",
                        rules: [
                            {
                                required: true,
                                message: "Please fill out information"
                            }
                        ],
                        validateTrigger: [
                            "onChange"
                        ],
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* Input */.I, {
                            "aria-label": "other channel"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                        id: "submit-button",
                        htmlType: "submit",
                        size: "large",
                        actionType: "primary",
                        disabled: verificationDisabled,
                        onClick: onVerify,
                        "aria-label": "submit form",
                        children: buttonText
                    })
                ]
            })
        })
    });
});

// EXTERNAL MODULE: ../../node_modules/firebase/app/dist/index.esm.js
var dist_index_esm = __webpack_require__(35532);
// EXTERNAL MODULE: ../../libs/data-access/src/generated/index.tsx + 5 modules
var generated = __webpack_require__(20229);
;// CONCATENATED MODULE: ../../libs/ui-components/src/lib/common/PhoneAuthenticationForm/AuthForm/index.tsx









const AuthForm = (param)=>{
    let { header , onSuccess , ...props } = param;
    const [form] = Form/* Form.useForm */.l.useForm();
    const formRef = (0,react.useRef)(null);
    const { loading: userWithPhoneExistsLoading , refetch: userWithPhoneExists  } = (0,generated/* useUserWithPhoneExistsQuery */.UUK)({
        skip: true
    });
    const { wasPhoneNumberProvided , isVerificationLoading , setNewRecaptchaVerifierInstance , /* login, signup, acceptInvitation */ authenticate , verifyCode , reset , /* changePhone */ sendVerificationCode , updatePhone  } = usePhoneAuthentication();
    const onAuthenticate = (0,react.useCallback)(async ()=>{
        if (props.flow === "acceptInvitation") await props.safeLogout();
        try {
            var ref;
            await setNewRecaptchaVerifierInstance();
            const { phone: _phone  } = await form.validateFields([
                "phone"
            ]);
            const phone = src_phone/* normalize */.F(_phone);
            form.setFieldsValue({
                verificationCode: ""
            });
            const { data  } = await userWithPhoneExists({
                input: {
                    phone,
                    userRole: props.flow === "login" ? props.userRole : undefined
                }
            });
            const userWithProvidedNumberAlreadyExist = data.userWithPhoneExists;
            if (props.flow === "login" && !userWithProvidedNumberAlreadyExist) {
                message/* message.error */.y.error(props.userNotFoundErrorMessage);
                return false;
            } else if (props.flow !== "login" && userWithProvidedNumberAlreadyExist) {
                form.setFields([
                    {
                        name: "phone",
                        errors: [
                            "User with this phone number already exists"
                        ]
                    }
                ]);
                return false;
            }
            if (props.flow !== "changePhone") {
                await authenticate(phone);
            } else {
                await sendVerificationCode(phone);
            }
            (ref = formRef.current) === null || ref === void 0 ? void 0 : ref.focusVerificationCodeInput();
            return true;
        } catch (e) {
            console.error(e);
            esm/* captureException */.Tb(e);
            message/* message.error */.y.error("Too many attempts, please try again later.");
            return false;
        }
    }, [
        form,
        authenticate,
        userWithPhoneExists,
        setNewRecaptchaVerifierInstance,
        sendVerificationCode,
        props
    ]);
    const onVerify = (0,react.useCallback)(async ()=>{
        const values = await form.validateFields();
        try {
            const user = props.flow !== "changePhone" ? await verifyCode(values.verificationCode) : await updatePhone(values.verificationCode);
            onSuccess(user, {
                ...values,
                phone: src_phone/* normalize */.F(values.phone)
            });
            reset();
            form.resetFields();
        } catch (e) {
            if (e instanceof dist_index_esm/* FirebaseError */.ZR && [
                "auth/user-disabled",
                "auth/invalid-verification-id"
            ].includes(e.code)) {
                form.setFields([
                    {
                        name: "verificationCode",
                        errors: [
                            "Your account has been disabled. Contact us at vetters@vette.io for assistance."
                        ]
                    }
                ]);
            } else {
                form.setFields([
                    {
                        name: "verificationCode",
                        errors: [
                            "Invalid verification code"
                        ]
                    }
                ]);
            }
        }
    }, [
        form,
        verifyCode,
        updatePhone,
        onSuccess,
        reset,
        props
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Form_Form, {
        form: form,
        ref: formRef,
        header: header,
        onAuthenticate: onAuthenticate,
        onVerify: onVerify,
        isVerificationLoading: isVerificationLoading || userWithPhoneExistsLoading,
        verificationDisabled: !wasPhoneNumberProvided,
        buttonText: props.flow === "login" ? "Log In" : props.flow === "signup" ? "Sign Up" : props.flow === "acceptInvitation" ? "Join team" : props.flow === "changePhone" ? "Save new number" : "",
        gatherName: props.flow === "acceptInvitation" || props.flow === "signup",
        gatherChannel: props.flow === "signup",
        phoneNumberLabel: props.flow === "changePhone" ? "New phone number" : undefined
    });
};


/***/ }),

/***/ 72131:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ Form; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86868);
/* harmony import */ var _vette_common_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21206);




// eslint-disable-next-line @typescript-eslint/no-explicit-any
const recursiveTrimValue = (value)=>_vette_common_utils__WEBPACK_IMPORTED_MODULE_2__/* .recursiveApplyTransformation */ .P(value, (val)=>val.trim());
const Form = (param)=>{
    let { onFinish , ...formProps } = param;
    const onFinishWrapper = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (value)=>{
        const trimmedValue = recursiveTrimValue(value);
        return onFinish === null || onFinish === void 0 ? void 0 : onFinish(trimmedValue);
    }, [
        onFinish
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        onFinish: onFinishWrapper,
        ...formProps
    });
};
Form.useForm = antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"].useForm */ .Z.useForm;
Form.useFormInstance = antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"].useFormInstance */ .Z.useFormInstance;
Form.useWatch = antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"].useWatch */ .Z.useWatch;
Form.List = antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"].List */ .Z.List;
Form.ErrorList = antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"].ErrorList */ .Z.ErrorList;
Form.Item = antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"].Item */ .Z.Item;
Form.Provider = antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"].Provider */ .Z.Provider;
Form.create = antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"].create */ .Z.create;


/***/ }),

/***/ 74606:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "x": function() { return /* binding */ FormItem_FormItem; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/common-utils/src/helpers.ts
var helpers = __webpack_require__(21206);
// EXTERNAL MODULE: ../../node_modules/antd/es/grid/index.js
var grid = __webpack_require__(68358);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(58694);
;// CONCATENATED MODULE: ../../libs/ui-components/src/lib/common/atoms/FloatLabel/styles.ts

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n\n  & .ant-input {\n    padding-top: 16px;\n    padding-bottom: 8px;\n  }\n\n  & .react-tel-input > .ant-input {\n    padding-top: 18px;\n    padding-bottom: 6px;\n    height: 50px;\n  }\n\n  & .label {\n    font-size: 15px;\n    font-weight: normal;\n    position: absolute;\n    pointer-events: none;\n    left: 12px;\n    top: 12px;\n    transition: 0.2s ease all;\n    color: ",
        ";\n  }\n\n  & .label-float {\n    top: 5px;\n    font-size: 10px;\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}

const MinimalInput = styled_components_browser_esm/* default.div */.ZP.div(_templateObject(), (param)=>{
    let { theme  } = param;
    return theme.colors.grey30;
});

;// CONCATENATED MODULE: ../../libs/ui-components/src/lib/common/atoms/FloatLabel/index.tsx



const FloatLabel = (param)=>{
    let { label , value , children  } = param;
    const [focus, setFocus] = (0,react.useState)(false);
    const labelClass = focus || value && (value === null || value === void 0 ? void 0 : value.length) !== 0 ? "label label-float" : "label";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MinimalInput, {
        className: "float-label",
        onBlur: ()=>setFocus(false),
        onFocus: ()=>setFocus(true),
        children: [
            children,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                className: labelClass,
                children: label
            })
        ]
    });
};

// EXTERNAL MODULE: ../../libs/ui-components/src/lib/common/theme.ts
var theme = __webpack_require__(32657);
// EXTERNAL MODULE: ../../libs/ui-components/src/lib/common/atoms/Typography/styles.tsx
var styles = __webpack_require__(93430);
// EXTERNAL MODULE: ../../libs/ui-components/src/lib/common/atoms/Form/index.tsx
var Form = __webpack_require__(72131);
;// CONCATENATED MODULE: ../../libs/ui-components/src/lib/common/atoms/FormItem/styles.ts

function styles_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n      &.ant-form-item-has-error .ant-form-item-label > label {\n        color: #ff4d4f;\n      }\n    "
    ]);
    styles_templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n      & .ant-form-item-label > label .ant-form-item-tooltip {\n        background: ",
        ";\n        color: ",
        ";\n        border-radius: 50%;\n      }\n    "
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline;\n\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 1;\n  margin-bottom: 0;\n\n  ",
        "\n  &\n    .ant-form-item-label {\n    padding-bottom: 0;\n    white-space: unset;\n    text-align: left;\n    line-height: 1.6;\n\n    > label {\n      height: fit-content;\n      margin-top: 5px;\n      margin-bottom: 5px;\n    }\n\n    > label::after {\n      display: none;\n    }\n  }\n\n  &\n    .ant-form-item-label\n    > label.ant-form-item-required:not(\n      .ant-form-item-required-mark-optional\n    )::before {\n    display: none;\n  }\n\n  & .ant-form-item-control {\n    width: 100%;\n  }\n\n  .ant-form-item-with-help .ant-form-item-explain {\n    min-height: 0px;\n  }\n\n  .ant-form-item-explain-error {\n    font-size: 10px;\n  }\n\n  &.ant-form-item-has-error .ant-input {\n    border-color: #ff4d4f;\n    box-shadow: ",
        ";\n  }\n\n  ",
        "\n\n  .ant-input-status-error {\n    box-shadow: ",
        ";\n  }\n\n  .ant-select-status-error > .ant-select-selector {\n    box-shadow: ",
        ";\n  }\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: -15px;\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-left: 20px;\n  max-height: 50px;\n  overflow-y: scroll;\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 10px;\n  font-weight: 600;\n  color: ",
        ";\n"
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}


const { Item  } = Form/* Form */.l;
const FormItem = (0,styled_components_browser_esm/* default */.ZP)(Item)(_templateObject2(), (param)=>{
    let { $redLabelOnError  } = param;
    return $redLabelOnError && (0,styled_components_browser_esm/* css */.iv)(styles_templateObject());
}, (param)=>{
    let { theme  } = param;
    return "inset 0 0 0 500px ".concat(theme.colors.red20);
}, (param)=>{
    let { $hasToolTip  } = param;
    return $hasToolTip && (0,styled_components_browser_esm/* css */.iv)(_templateObject1(), (param)=>{
        let { theme  } = param;
        return theme.colors.grey60;
    }, (param)=>{
        let { theme  } = param;
        return theme.colors.white;
    });
}, (param)=>{
    let { theme  } = param;
    return "inset 0 0 0 500px ".concat(theme.colors.red20);
}, (param)=>{
    let { theme  } = param;
    return "inset 0 0 0 500px ".concat(theme.colors.red20);
});
const CustomErrorDisplay = styled_components_browser_esm/* default.div */.ZP.div(_templateObject3());
const List = styled_components_browser_esm/* default.ul */.ZP.ul(_templateObject4());
const ListItem = styled_components_browser_esm/* default.li */.ZP.li(_templateObject5(), (param)=>{
    let { theme  } = param;
    return theme.colors.red60;
});

;// CONCATENATED MODULE: ../../libs/ui-components/src/lib/common/atoms/FormItem/index.tsx








// eslint-disable-next-line @typescript-eslint/no-explicit-any
const recursiveTrimStartValue = (value)=>{
    return helpers/* recursiveApplyTransformation */.P(value, (val)=>val.trimStart());
};
const FormItem_FormItem = (param)=>{
    let { ignoreNormalize , compact , customError , redLabelOnError =false , ...formItemProps } = param;
    const { xs  } = grid/* default.useBreakpoint */.ZP.useBreakpoint();
    const [currentValue, setCurrentValue] = (0,react.useState)(formItemProps.initialValue);
    const customErrorBox = customError ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(CustomErrorDisplay, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* Text */.xv, {
                $size: 9,
                $weight: 600,
                $color: theme/* theme.colors.red60 */.r.colors.red60,
                children: customError.title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(List, {
                children: customError.errors.map((e, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem, {
                        children: e
                    }, index))
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    if (compact && xs) {
        const { label , ...restFormItemProps } = formItemProps;
        const normalize = (value)=>{
            const finalValue = !ignoreNormalize ? recursiveTrimStartValue(value) : value;
            setCurrentValue(finalValue);
            return finalValue;
        };
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FloatLabel, {
            label: formItemProps.label,
            value: currentValue,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FormItem, {
                    $redLabelOnError: redLabelOnError,
                    normalize: normalize,
                    ...restFormItemProps
                }),
                customErrorBox
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormItem, {
                $redLabelOnError: redLabelOnError,
                normalize: !ignoreNormalize ? recursiveTrimStartValue : undefined,
                ...formItemProps,
                $hasToolTip: !!formItemProps.tooltip
            }),
            customErrorBox
        ]
    });
};


/***/ }),

/***/ 68880:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "I": function() { return /* binding */ Input; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/antd/es/input/index.js + 7 modules
var input = __webpack_require__(49211);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(58694);
// EXTERNAL MODULE: ../../libs/ui-components/src/lib/common/atoms/Typography/styles.tsx
var styles = __webpack_require__(93430);
;// CONCATENATED MODULE: ../../libs/ui-components/src/lib/common/atoms/Input/styles.ts

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 10px;\n  margin-top: 4px;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}


const Hint = (0,styled_components_browser_esm/* default */.ZP)(styles/* Text */.xv)(_templateObject());

;// CONCATENATED MODULE: ../../libs/ui-components/src/lib/common/atoms/Input/index.tsx




const Input = /*#__PURE__*/ (0,react.forwardRef)((param, ref)=>{
    let { size ="large" , optionalText , ...props } = param;
    const inputRef = (0,react.useRef)(null);
    (0,react.useImperativeHandle)(ref, ()=>{
        return {
            focus: ()=>{
                var ref;
                return (ref = inputRef.current) === null || ref === void 0 ? void 0 : ref.focus();
            }
        };
    });
    const numberValidatorProp = (e)=>{
        props.type === "number" && [
            "e",
            "E",
            "+",
            "-"
        ].includes(e.key) && e.preventDefault();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* default */.Z, {
                ...props,
                onKeyDown: numberValidatorProp,
                size: size,
                ref: inputRef
            }),
            optionalText && /*#__PURE__*/ (0,jsx_runtime.jsx)(Hint, {
                type: "secondary",
                children: optionalText
            })
        ]
    });
});


/***/ }),

/***/ 61035:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "P": function() { return /* binding */ Select_Select; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/antd/es/select/index.js + 47 modules
var es_select = __webpack_require__(76496);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(58694);
// EXTERNAL MODULE: ../../node_modules/@mui/icons-material/ArrowDropDown.js
var ArrowDropDown = __webpack_require__(65643);
;// CONCATENATED MODULE: ../../libs/ui-components/src/lib/common/atoms/Select/styles.ts

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  font-weight: 500;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}



const Select = (0,styled_components_browser_esm/* default */.ZP)(es_select/* default */.Z)(_templateObject());
const DropDownIcon = (0,styled_components_browser_esm/* default */.ZP)(ArrowDropDown/* default */.Z)(_templateObject1(), (param)=>{
    let { theme  } = param;
    return theme.colors.grey70;
});

;// CONCATENATED MODULE: ../../libs/ui-components/src/lib/common/atoms/Select/index.tsx




const { Option  } = es_select/* default */.Z;
const Select_Select = function(param) {
    let { children , ...props } = param;
    var ref;
    // In version https://ant.design/changelog#4.18.0 antdesign introduced a breaking change
    // https://github.com/ant-design/ant-design/pull/33364
    // messing up type definition for Select to make it more generic
    // cannot be used along with styled-components
    const HackedSelect = Select;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HackedSelect, {
        suffixIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(DropDownIcon, {}),
        ...props,
        children: (ref = props.option) === null || ref === void 0 ? void 0 : ref.map((valueOrObject)=>{
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Option, {
                value: typeof valueOrObject === "string" ? valueOrObject : valueOrObject.value,
                children: typeof valueOrObject === "string" ? valueOrObject : valueOrObject.text
            }, typeof valueOrObject === "string" ? valueOrObject : valueOrObject.value);
        })
    });
};


/***/ })

}]);